import { render, staticRenderFns } from "./ProductsQuotationForm.vue?vue&type=template&id=06907792&"
import script from "./ProductsQuotationForm.vue?vue&type=script&lang=js&"
export * from "./ProductsQuotationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports